import Card from "components/card";
import CardMenu from "components/card/CardMenu";
import React, { useMemo, useState } from "react";
import { MdModeEditOutline, MdOutlinePassword } from "react-icons/md";
import { useSelector } from "react-redux";
import UpdatePassword from "./UpdatePassword";
import UpdateProfile from "./UpdateProfile";

const General = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const { profile = {} } = useSelector((state) => state.auth.permissions || {});
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenEdit, setIsOpenEdit] = useState(false);

  const openModalEdit = () => setIsOpenEdit(true);

  const openModal = () => setIsOpen(true);

  const userDetails = useMemo(
    () => [
      {
        label: "Full Name",
        value: `${userInfo?.firstname || ""} ${userInfo?.lastname || ""}`,
      },
      { label: "Email", value: userInfo?.email || "N/A" },
      { label: "Mobile", value: userInfo?.mobile || "N/A" },
      { label: "User Type", value: userInfo?.userType || "N/A" },
      {
        label: "Active Status",
        value: userInfo?.isActive ? "Active ✅" : "Inactive ❌",
      },
    ],
    [userInfo]
  );

  return (
    <>
      <UpdateProfile isOpen={isOpenEdit} setIsOpen={setIsOpenEdit} />
      <UpdatePassword isOpen={isOpen} setIsOpen={setIsOpen} />

      <Card extra={"w-full h-full p-3"}>
        {/* Header */}
        <div className="mb-8 mt-2 flex w-full items-center justify-between">
          <h4 className="px-2 text-xl font-bold text-navy-700 dark:text-white">
            General Information
          </h4>

          <CardMenu
            items={[
              profile?.edit && {
                label: "Edit Profile",
                icon: <MdModeEditOutline />,
                onClick: () => openModalEdit(),
              },
              profile?.updatePassword && {
                label: "Change Password",
                icon: <MdOutlinePassword />,
                onClick: () => openModal(),
              },
            ].filter(Boolean)}
          />
        </div>
        {/* Cards */}
        <div className="grid grid-cols-2 gap-4 px-2">
          {userDetails.map((item, index) => (
            <div
              key={index}
              className="flex flex-col items-start justify-center rounded-2xl bg-white bg-clip-border px-3 py-4 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none"
            >
              <p className="text-sm text-gray-600">{item.label}</p>
              <p className="text-base font-medium text-navy-700 dark:text-white">
                {item.value}
              </p>
            </div>
          ))}
        </div>
      </Card>
    </>
  );
};

export default General;
